/* @flow */

export default class InvoiceCompensation {
  id: number;
  amount: number;
}
